var _rect, _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopBusWaltti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4003 21H9.60023C8.71629 21 8 20.2837 8 19.4003V6.60023C8 5.71629 8.71629 5 9.60023 5H22.4003C23.2843 5 24.0006 5.71629 24.0006 6.60023V19.4003C24 20.2837 23.2837 21 22.4003 21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 6.60022H11.9506C11.5036 6.60022 11.1406 6.9626 11.1406 7.41021V17.1295C11.1406 17.5766 11.503 17.9395 11.9506 17.9395H20.05C20.497 17.9395 20.86 17.5771 20.86 17.1295V7.41021C20.8594 6.9626 20.497 6.60022 20.05 6.60022ZM14.2 7.32385H17.8V7.93346H14.2V7.32385ZM12.5704 16.4878C12.2278 16.4878 11.9506 16.21 11.9506 15.868C11.9506 15.5254 12.2283 15.2482 12.5704 15.2482C12.913 15.2482 13.1902 15.5259 13.1902 15.868C13.1907 16.21 12.913 16.4878 12.5704 16.4878ZM19.4296 16.4878C19.087 16.4878 18.8099 16.21 18.8099 15.868C18.8099 15.5254 19.0876 15.2482 19.4296 15.2482C19.7722 15.2482 20.0494 15.5259 20.0494 15.868C20.05 16.21 19.7722 16.4878 19.4296 16.4878ZM20.05 13.2517C20.05 13.3985 19.9517 13.5266 19.8101 13.5644C19.2456 13.7163 17.7481 14.0679 16 14.0679C14.2519 14.0679 12.7544 13.7163 12.1899 13.5644C12.0483 13.5266 11.9501 13.3985 11.9501 13.2517V8.86255C11.9501 8.68362 12.0951 8.53855 12.274 8.53855H19.7254C19.9043 8.53855 20.0494 8.68362 20.0494 8.86255V13.2517H20.05Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1907 17.9254H11.9506V19.4003H13.1907V17.9254Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 17.9254H18.8099V19.4003H20.05V17.9254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopBusWaltti);
export default __webpack_public_path__ + "static/media/stop-bus-waltti.be520614970d1be5c78a809ad87bd506.svg";
export { ForwardRef as ReactComponent };